import { Application } from '@monorepo/types';

const project: Application = import.meta?.env
  ? import.meta.env['VITE_PROJECT']
  : Application.THE5ERS;

export const getProject = () => {
  const is5ers = project === Application.THE5ERS;
  const isTtp = project === Application.TTP;

  const projectClassName = is5ers ? 'the5ers' : 'ttp';

  return {
    project,
    is5ers,
    isTtp,
    projectClassName,
  };
};
